<template>
    <tab-layout :buttons="more.buttons" :parameters="parameters" :permissions="permissions">
        <!-- TAB TITLE -->
        <template #title>
            {{ $l10n.__('Sociétés liées') }}
        </template>

        <template #content>
            <div class="prelative">
                <preloader :display="loading" class="mt-3" />

                <div v-if="!loading && thirds.length > 0" class="flex-column flex">
                    <div>
                        <!-- Active -->
                        <section v-if="activeThirds.length > 0">
                            <div v-for="third in activeThirds" :key="third.id" class="well mb-2">
                                <third-card :third="third" :permissions="permissions" />
                            </div>
                        </section>

                        <!-- Archived -->
                        <section v-if="archivedThirds.length > 0">
                            <h4>{{ $l10n.__('Sociétés archivées') }}</h4>
                            <div v-for="third in archivedThirds" :key="third.id" class="well mb-2">
                                <third-card :third="third" :permissions="permissions" />
                            </div>
                        </section>

                        <!-- Scroll info -->
                        <CompassButton
                            v-if="infiniteLoading"
                            :label="$t.__('common.actions.load_more')"
                            :loading="loading"
                            @click="fetch"
                        />
                    </div>
                </div>
                <div v-else>
                    <div class="placeholder" v-if="!loading">
                        <p>{{ placeholder }}</p>
                    </div>
                </div>
            </div>
        </template>
    </tab-layout>
</template>

<script>
import OverviewTabMixin from './OverviewTabMixin';
import { thirdsActions } from './mapping/PeopleMapping';
import { buildUrl, formatActions } from '../../../helpers';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import ThirdCard from 'vcomponents/utilities/ThirdCard.vue';

export default {
    mixins: [OverviewTabMixin],

    data() {
        return {
            loading: true,
            thirds: [],
            permissions: {},
            actions: thirdsActions,
            infiniteLoading: false,
            page: 1,
            lastCallEmpty: false,
        };
    },

    created() {
        this.fetch();
    },

    methods: {
        buildUrl,
        formatActions,
        fetch($state) {
            if (this.thirds.length == 0) {
                this.loading = true;
            }
            this.$ajax.get(
                `/rest/${this.linkedtype}s/${this.linkedid}/thirds`,
                {
                    page: this.page,
                },
                (response) => {
                    this.permissions = { ...this.permissions, ...response.permissions };
                    if (response.thirds.length > 0) {
                        _.each(response.thirds, (third) => {
                            third.actions = this.setActions(third);
                            this.thirds.push(third);
                        });
                        this.page++;
                        this.infiniteLoading = response.nbrPages > response.page;

                        if ($state) {
                            $state.loaded();
                        }
                    } else {
                        if ($state) {
                            $state.complete();
                        }
                    }
                    this.loading = false;
                },
                (error) => {
                    Push.error(
                        this.$l10n.__("Une erreur s'est produite lors du chargement des données."),
                        false,
                    );
                },
            );
        },

        setActions(third) {
            let peopleParameters = [
                {
                    key: 'id',
                    value: third.id,
                },
                {
                    key: 'peopleid',
                    value: this.linkedid,
                },
                {
                    key: 'contactid',
                    value: third.contactId,
                },
                {
                    key: 'relationtype',
                    value: third.relationType,
                },
            ];
            return this.formatActions(this.actions, third, peopleParameters);
        },
    },

    computed: {
        parameters() {
            return [
                {
                    key: 'id',
                    value: this.$store.getters.linkedid,
                },
            ];
        },

        activeThirds() {
            return this.thirds.filter((item) => !item.isArchived);
        },
        archivedThirds() {
            return this.thirds.filter((item) => item.isArchived);
        },

        placeholder() {
            return this.$l10n.__('Aucune société associée trouvée');
        },
    },

    components: {
        Preloader,
        TabLayout,
        ThirdCard,
    },
};
</script>
